// extracted by mini-css-extract-plugin
export var subtitle = "_8u-2";
export var title = "_8u-0";
export var titleNoWrap = "_8u-1";